import request from "../utils/request";


const moduleApi = {
  ModuleList: '/module/search/',
  Module: '/module',
  Business: '/module/business',
  Patient: "/module/patient",
  Summary: '/module/summary',
  SummaryList: "/module/summary/list",
  SummaryConfig: "/module/summary/config",
  MedicalRecord: "/medical/record/",
  QuestionPatientRecord: "/module/questionnaire/patient/record",
  QuestionRecord: "/module/questionnaire/person/record",
  Trend: "/module/trend",
  Config: "/config/"
}
export function getModuleListApi({id, keyword, page, size, config_type}) {
  return request({
    url: moduleApi.Module,
    method: "get",
    params: {
      page, size, keyword, config_type
    },

  })
}
/**
 * 
 * @param {*} parameter 
 * id name alias type route sort show diseaseId diseaseName
 * @returns 
 */
export function editModuleApi(parameter) {
  return request({
    url: moduleApi.Module,
    method: "post",
    data: parameter,

  })
}
export function deleteModuleApi(id) {
  return request({
    url: moduleApi.Module + '/' + id,
    method: "delete",

  })
}
export function editBusinessApi(parameter) {
  return request({
    url: moduleApi.Business,
    method: "post",
    data: parameter,

  })
}
export function deleteBusinessApi(id) {
  return request({
    url: moduleApi.Business + '/' + id,
    method: "delete",

  });
}
// 获取患者模块展示配置 0 筛查 1 慢病
export function getPatientModuleListApi(patient_id, config_type) {
  return request({
    url: moduleApi.Patient,
    method: "get",
    params: {
      patient_id,
      config_type
    },
  });
}
// 末次评估
export function getPatientLastModuleSummaryApi(patient_id) {
  return request({
    url: moduleApi.Summary,
    method: "get",
    params: {
      patient_id
    },

  });
}

// 列表 配置
export function getModuleSummaryListApi(parameter) {
  return request({
    url: moduleApi.SummaryList,
    method: "get",
    params: parameter,

  })
}

export function addModuleSummaryApi(parameter) {
  return request({
    url: moduleApi.SummaryConfig,
    method: "post",
    data: parameter,

  })
}

export function deleteModuleSummaryApi(id) {
  return request({
    url: moduleApi.SummaryConfig + '/' + id,
    method: "delete",
  })
}

export function getPatientMedicalRecordApi(parameter) {
  return request({
    url: moduleApi.MedicalRecord,
    method: "get",
    params: parameter
  })
}
export function updatePatientMedicalRecordApi(data) {
  return request({
    url: moduleApi.MedicalRecord,
    method: "post",
    data
  })
}
export function deletePatientMedicalRecordApi(id) {
  return request({
    url: moduleApi.MedicalRecord + id,
    method: "delete",
  })
}
export function getQuestionPersonRecordListApi(parameter) {
  return request({
    url: moduleApi.QuestionRecord,
    method: "get",
    params: parameter
  })
}
export function deleteQuestionPersonRecordApi(parameter) {
  return request({
    url: moduleApi.QuestionRecord,
    method: "delete",
    params: parameter
  })
}
export function getQuestionPatientRecordApi(parameter) {
  return request({
    url: moduleApi.QuestionPatientRecord,
    method: "get",
    params: parameter
  })
}
export function deleteQuestionPatientRecordApi(parameter) {
  return request({
    url: moduleApi.QuestionPatientRecord,
    method: "delete",
    params: parameter
  })
}

export function getModuleTrendApi(data) {
  return request({
    url: moduleApi.Trend,
    method: "post",
    data
  })
}
export function getConfigApi(parameter) {
  return request({
    url: moduleApi.Config,
    method: "get",
    params: parameter
  })
}